module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_03.e9709bf9.webp";